"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _sceneLayoutSelector = require("@studio/program/sceneLayout/sceneLayoutSelector");
var _actionUtils = require("../../../utils/actionUtils");
var _setSceneLayoutRealtime = _interopRequireDefault(require("../../../actions/program/setSceneLayoutRealtime"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function sceneLayoutChanged(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var notifyingDirector = _ref2.notifyingDirector,
    layout = _ref2.layout;
  var state = getState();
  var sceneLayout = state.sceneLayout;
  if (!(0, _actionUtils.isSameAttendee)(notifyingDirector, state)) {
    // if the layout has changed we sync it to the new value
    if (!(0, _sceneLayoutSelector.isLayout)(sceneLayout, layout)) {
      dispatch((0, _setSceneLayoutRealtime["default"])(layout));
    }
  }
}
var _default = exports["default"] = sceneLayoutChanged;